
function AdminPolicyFormCtrl($scope, $controller, $location,  $timeout, $state, $filter, IconsService, GeneralUtilsService) {

    
    var icons = IconsService.getIcons("policy");

    $scope.datamodified = false;
    $scope.exceptionsdatamodified = false;
    
    $scope.grouplookup = {
        url: '/groupItems',
        method: 'POST',
        icons: icons
    };


    // define rules of table
    var rulesDef = {};

    // parent controller (inheritance)
   $controller('BasePolicyFormCtrl', {$scope: $scope, $location:$location, $timeout:$timeout, rulesDef:rulesDef, $state: $state, $filter: $filter,IconsService:IconsService, GeneralUtilsService: GeneralUtilsService});

    $scope.ruleDef.removeURL = "removeBySystem"; //when removing traffic rules from admin page - audit as SystemOnly

    // Get all accounts
    store.fetch({
        path: "/accounts",
        method: 'POST',
        queryParams: {'viewType':'SimpleList'},
        success: function(data) {
            $scope.rulesConfig.accounts = [{id:-1,name:''}].concat(data.items);
        }
     });

    $scope.ruleDef.fields.splice(0, 0, {"label":"Account","path":"accountId",noSort:true, "template":"<select ng-model='item.accountId' style='width: 150px' class='form-control' ng-options='account.id as account.name for account in tableConfig.accounts'></select>"});

    var ruleCollection = $scope.ruleDef.ruleCollection;
    var ruleType = $scope.ruleDef.type;

    
    $scope.removeRuleFilters = function(){
         window.location.href = $scope.ruleDef.redirect;
    };
	     
    $scope.saveChanges = function(){
        var config = $scope.rulesConfig;
        $scope.allAccounts = {};
        $scope.ignoreChanges = true;
        $scope.allAccounts[ruleCollection] = config.items;
        $scope.allAccounts[ruleCollection].forEach(function(rule){
            var orig = $scope.origRules[rule.id];
            if(!orig || !angular.equals(rule,orig)){
                rule.changed = true;
            }
            if (rule.fileSize){
                rule.fileSize = $filter('fromUnit')(rule.fileSize,"MB");
            }
            if (rule.limitRecord){
                rule.limitRecord = $filter('fromUnit')(rule.limitRecord,"KB");
            }
        });
      	$scope.doSave("Rules saved successfully",null,config,[ruleCollection]);
      	$scope.allAccounts[ruleCollection].forEach(function(rule){
            if (rule.fileSize){
                rule.fileSize = $filter('toUnit')(rule.fileSize,"MB");
            }
            if (rule.limitRecord){
                rule.limitRecord = $filter('toUnit')(rule.limitRecord,"KB");
            }
        });
    };


    $scope.doSave = function(message,onSuccess,config,fields){
        if(!fields){
          fields = [];
        }
        $scope.loading = true;

		store.save({
            path: "/editTrafficLoggingRules",
            data: $scope.allAccounts,
            dataObj: 'json',
            queryParams: {'save':true,'fields':angular.toJson(fields)},
            success: function(data) {
                $timeout(function() {
                    $scope.loading = false;
                }, 0);

                $scope.ignoreChanges = false;
                $scope.$root.handleServerResponse(data,"", message ,onSuccess);
                if(data.status !== "ERROR"){
                    $scope[(config.exceptions?"exceptions":"") + "datamodified"] = new Date().getTime();
                }
            }

	    });

    };

    $scope.selectedApps = [];
    
    $scope.selectApp = function(app){
        GeneralUtilsService.toggleSelection($scope.selectedApps,app.id);
    };

	 store.fetch({
         path: "/apps",
        success: function(data) {
            $scope.apps = data;
            for(var key in data){
              $scope.rulesConfig.servicesNames[data[key].id] = data[key].display_name;
            }
        }
     });

    // override parent
    $scope.$root.hasChanges = function(id){
        var rulesChanged;
        if(id) {
        	rulesChanged = $("#" + id + " .warning:visible").length > 0;
        }
        else {
            rulesChanged = $(".warning:visible").length > 0;
        }
        return rulesChanged;
    };


    $scope.AdminRulesConfig = {
            policy:{},
            accountId : $state.params.accountId,
            dataURL : function(){
                var accountId = $state.params.accountId;
                var ruleIdParam = $scope.ruleId ? "&ruleId=" + $scope.ruleId : "";
                return "/trafficLoggingAdminList?type=" + ruleType.toUpperCase() + (accountId ? "&accountId=" + accountId : "") + "&ruleAction=" + this.ruleAction + ruleIdParam;
            },
            parseData : $scope.parseTrafficData,
            fields : [
                {"class":"toggle-status",noSort:true, "label":"Results","path":"pcapCount","template":"<div style='padding-left: 15px' tooltip tooltipvalue='item.pcapLastModifiedMoment' >{{item.pcapCount}}</div>"},
                {"class":"toggle-status",noSort:true, "label":"Id","path":"id","template":"<span>{{item.id}}</span>"}
            ],
            type : "AccessRule",
            selectedItems:[],
            items:[],
            hideCheckboxes: true,
            mouseenter: function (item, pos){
                if(item.type === "GROUP"){
                    $scope.grouplookup.params = {
                        groupId: item.id
                    };
                    $scope.grouplookup.pos = pos;
                }
            },
            mouseleave: function (item){
                $scope.grouplookup.pos = null;
            },
            noReload:true,
            editTable:false,
            noAutoSelect : true,
            noSearch:true,
            noDisable: true,
            innerTable : $scope.rulesConfig.innerTable,
            innerTableDataURL: $scope.rulesConfig.innerTableDataURL,
            innerTableParseData: $scope.rulesConfig.innerTableParseData,
            expand: $scope.rulesConfig.expand
        };
}